import { colors } from '@skyslope/mache';

export const rippleStyles = `
  & .MuiTouchRipple-child {
    backgroundColor: ${colors.blue[200]},
  }
`;
